import { render, staticRenderFns } from "./AffiliateClients.vue?vue&type=template&id=71747f18&scoped=true"
import script from "./AffiliateClients.vue?vue&type=script&lang=js"
export * from "./AffiliateClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71747f18",
  null
  
)

export default component.exports